import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, bindResource, rpcCrudService } from "kea-resource";
import { CampoRepetidoIdentificacion, ResourceIdentificacionRepetido } from "./identificacion";

const controller = rpcController("CorteDiario");
const crud = rpcCrudService<models.CorteDiario, models.CorteDiarioDTO>(controller);

const otros = {

    /**
 * Genera el corte del día según el usuario y la sucursal que lo llama
 * @param idSucursal 
 * @param idUsuario 
 */
    GenerarCorteDia: async (idUsuario: number): Promise<number> => await controller("GenerarCorteDia", { idUsuario }),

    ImprimirMatriz: async (idCorte: number): Promise<string> => await controller("ImprimirMatriz", { idCorte }),

}

export const CorteDiario = cacheResource({
    ...crud,
    ...otros
}, {
        ImprimirMatriz: true
    }, {
        GenerarCorteDia: true
    })


// WEBPACK FOOTER //
// ./app/resources/items/cortediario.ts